export default __webpack_public_path__ + "static/media/self_assessment_right.f37a06e4.png";